import React from 'react';
import { useTranslation } from 'react-i18next';
const ProductPrice = (props) => {
    var _a, _b, _c, _d, _e;
    const { t } = useTranslation();
    if (!props.price && !props.basePrice) {
        return React.createElement(React.Fragment, null);
    }
    if (props.basePrice) {
        return window.language == 'ja' ? (React.createElement(React.Fragment, null,
            props.basePrice,
            " ",
            t('label.from'))) : (React.createElement(React.Fragment, null,
            t('label.from'),
            " ",
            props.basePrice));
    }
    if (props.price.type === 'range') {
        if (window.language == 'ja') {
            // https://jira.industries-group.com/browse/ONE-35223
            return (React.createElement(React.Fragment, null, (_b = (_a = props.price.min) === null || _a === void 0 ? void 0 : _a.sales) === null || _b === void 0 ? void 0 :
                _b.formatted,
                " ",
                t('label.from')));
        }
        return (React.createElement(React.Fragment, null,
            t('label.from'),
            " ", (_d = (_c = props.price.min) === null || _c === void 0 ? void 0 : _c.sales) === null || _d === void 0 ? void 0 :
            _d.formatted));
    }
    return (React.createElement(React.Fragment, null, (_e = props.price.sales) === null || _e === void 0 ? void 0 : _e.formatted));
};
export default ProductPrice;
